import { LookupIntervalEnum, useLookup } from "@rentablo/api/apiv1";
import { RecommendedItems } from "../types";

export interface RecommendedItem {
  tickerSymbol: string;
  name: string;
  color: string;
}

const firstQuoteSeries = <T>(
  historicQuotes: { [key: string]: T[] } | undefined
): T[] => {
  if (!historicQuotes) return [];
  const series = Object.values(historicQuotes)[0];
  return series ?? [];
};

export const useRecommededHistoricQuotes = ({
  recommendedItems,
  startDate,
  endDate,
  interval,
  currency,
}: {
  recommendedItems: RecommendedItems;
  startDate?: Date;
  endDate?: Date;
  interval?: string;
  currency?: string;
}) => {
  const { recommender1, recommender2, recommender3 } = recommendedItems;
  const { data: recommendedData1, isLoading: isLoadingRecommendedData1 } =
    useLookup(
      {
        tickerSymbol: recommender1?.tickerSymbol!,
        interval: interval as LookupIntervalEnum,
        from: startDate?.toISOString()!,
        to: endDate?.toISOString()!,
        quoteProvider: "ariva",
        convertToCurrency: currency,
      },
      {
        enabled: Boolean(recommender1?.tickerSymbol),
      }
    );

  const { data: recommendedData2, isLoading: isLoadingRecommendedData2 } =
    useLookup(
      {
        tickerSymbol: recommender2?.tickerSymbol!,
        interval: interval as LookupIntervalEnum,
        from: startDate?.toISOString()!,
        to: endDate?.toISOString()!,
        quoteProvider: "ariva",
        convertToCurrency: currency,
      },
      {
        enabled: Boolean(recommender2?.tickerSymbol),
      }
    );

  const { data: recommendedData3, isLoading: isLoadingRecommendedData3 } =
    useLookup(
      {
        tickerSymbol: recommender3?.tickerSymbol!,
        interval: interval as LookupIntervalEnum,
        from: startDate?.toISOString()!,
        to: endDate?.toISOString()!,
        quoteProvider: "ariva",
        convertToCurrency: currency,
      },
      {
        enabled: Boolean(recommender3?.tickerSymbol),
      }
    );

  return {
    recommendedData1: firstQuoteSeries(recommendedData1?.historicQuotes),
    recommendedData2: firstQuoteSeries(recommendedData2?.historicQuotes),
    recommendedData3: firstQuoteSeries(recommendedData3?.historicQuotes),
    isLoading:
      isLoadingRecommendedData1 ||
      isLoadingRecommendedData2 ||
      isLoadingRecommendedData3,
  };
};
